import tabs, { en as tabsEN, ca as tabsCA } from './tabs'
import generalInfo, { en as generalInfoEN, ca as generalInfoCA } from './generalInfo'
import introductoryContent, { en as introductoryContentEN, ca as introductoryContentCA } from './introductoryContent'
import triggers, { en as triggersEN, ca as triggersCA } from './triggers'
import classes, { en as classesEN, ca as classesCA } from './classes'
import resourcePreview, { en as resourcePreviewEN, ca as resourcePreviewCA } from './preview'

export default {
  tabs,
  generalInfo,
  introductoryContent,
  triggers,
  classes,
  resourcePreview,
  saveChanges: 'Guardar cambios',
  saveAndContinue: 'Guardar y continuar',
  preview: 'Vista previa',
  untitled: 'Sin título',
  krea: 'Krea',
  backToKrea: 'Volver a Krea',
  saveChangesAndFinish: 'Guardar y finalizar',
  uncompletedFieldsError: 'Por favor, revisa los campos en rojo antes de continuar.'
}

export const en = {
  tabs: tabsEN,
  generalInfo: generalInfoEN,
  introductoryContent: introductoryContentEN,
  triggers: triggersEN,
  classes: classesEN,
  resourcePreview: resourcePreviewEN,
  saveChanges: 'Save changes',
  saveAndContinue: 'Save and continue',
  preview: 'Preview',
  untitled: 'Untitled',
  krea: 'Krea',
  backToKrea: 'Return to Krea',
  saveChangesAndFinish: 'Save and end',
  uncompletedFieldsError: 'Por favor, revisa los campos en rojo antes de continuar.'
}

export const ca = {
  tabs: tabsCA,
  generalInfo: generalInfoCA,
  introductoryContent: introductoryContentCA,
  triggers: triggersCA,
  classes: classesCA,
  resourcePreview: resourcePreviewCA,
  saveChanges: 'Desar els canvis',
  saveAndContinue: 'Desar i continuar',
  preview: 'Vista prèvia',
  untitled: 'Sense títol',
  krea: 'Krea',
  backToKrea: 'Tornar a Krea',
  saveChangesAndFinish: 'Desar i finalitzar',
  uncompletedFieldsError: 'Por favor, revisa los campos en rojo antes de continuar.'
}
